import { useEffect } from 'react';

export const useClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };

    document.addEventListener('mousedown', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
    };
  }, [ref, handler]);
};

const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

/**
 * Executes a callback when any of the HTMLElements given in the elementList resizes.
 * @param {callback} handler callback to execute when an observed entry resizes
 * @param {Array} elementList HTMLElements array to observe size changes
 */
export const useResizeWithoutInsertionToDOM = (handler, elementList) => {
  useEffect(() => {
    const entriesSeen = new Set();
    const debouncedHandler = debounce(handler, 100);

    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (!entriesSeen.has(entry.target)) {
          entriesSeen.add(entry.target);
        } else if (document.contains(entry.target)) {
          debouncedHandler(entries);
        }
      });
    });

    if (elementList.length > 0) {
      elementList.forEach((element) => {
        if (element && document.contains(element)) {
          observer.observe(element);
        }
      });
    }

    return () => {
      observer.disconnect();
    };
  }, [elementList, handler]);
};
